const hasClass = function (ele, cls) {
    if (ele) {
        return ele.className.match(new RegExp(`(\\s|^)${cls}(\\s|$)`));
    }
};
export default hasClass;
